import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const IntegrateAtsLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "IntegrateAtsLinks" */
      './IntegrateAtsLinks.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
